export { init, identify, track, globalClient } from "./client"
export type { ReliaClient, ReliaOptions, SessionEvent, SessionEventType } from "../core/types"

import { init, identify, track } from "./client"
export const Relia = { init, identify, track }
export default Relia
